import MuiDivider from '@mui/material/Divider';
import { ReactElement } from 'react';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';

type Props = {
  text: string;
};

export const Divider = ({ text }: Props): ReactElement => {
  const theme = useTheme();

  return (
    <MuiDivider
      sx={{
        '&::before, &::after': {
          borderColor: theme.palette.primary.main,
        },
      }}
    >
      <Typography
        variant="body2"
        color="primary"
        sx={{ fontSize: 12, letterSpacing: 0.4 }}
      >
        {text}
      </Typography>
    </MuiDivider>
  );
};
